import { CircularProgress } from "@mui/material";
import React from "react";

export default function PageLoading() {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 w-100">
      <div className="member-loader-div">
        <CircularProgress style={{ color: "navy" }} />
      </div>
    </div>
  );
}
